module.exports = __webpack_public_path__ + "img/F75F0B_461604_9A3004_FB9D2F-256px.e154c98f.png";